export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13977.3fc523e8.jpg";